<template>
  <div>
    <v-data-table
      :headers="headers"
      :hide-default-footer="showMore"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />

            <td class="nowrap">
              {{
                item.created_at
                  | moment(
                    "timezone",
                    currentUser.active_project.timezone,
                    "MM/DD/YY h:mm A"
                  )
              }}
            </td>
            <td>
              <router-link :to="`/pages/${item.id}/edit`">
                {{ item.page_title }}
              </router-link>
            </td>
            <td>
              {{ item.greenhouse_job_post_title }}
            </td>
            <td class="text-center nowrap">
              <Actions
                hide-duplicate
                hide-destroy
                :path="`/greenhouse/applications/${item.id}`"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <router-link
      v-if="showMore"
      :to="`/blog-articles/${entity.id}`"
      class="view-all"
    >
      View All Articles
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    showMore: Boolean,
    entity: Object,
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Date",
          align: "start",
          value: "created_at",
          sortable: true,
        },
        {
          text: "Page",
          align: "start",
          value: "page_title",
        },
        {
          text: "Job Post",
          align: "start",
          value: "greenhouse_job_post_title",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style></style>
